import Highcharts from 'highcharts'
import React, { useEffect } from 'react'
import difficulty from '../../assets/difficulty.svg'
import Card from '../Card/Card'
import './OverAllDifficulty.css'

const OverAllDifficulty = (props) => {
    useEffect(() => {
        let correct = []
        let incorrect = []
        let notAttempted = []
        correct.push(props.data.analytics.easyCorrect)
        correct.push(props.data.analytics.mediumCorrect)
        correct.push(props.data.analytics.hardCorrect)
        incorrect.push(props.data.analytics.easyIncorrect)
        incorrect.push(props.data.analytics.mediumInCorrect)
        incorrect.push(props.data.analytics.hardInCorrect)
        notAttempted.push(props.data.analytics.easyNotAttempted)
        notAttempted.push(props.data.analytics.mediumNotAttempted)
        notAttempted.push(props.data.analytics.hardNotAttempted)
        Highcharts.chart('overalldifficulty', {
            chart: {
                type: 'bar',
                height: props.width - 40,
                width: props.width,
            },
            colors: ['#2dce89', '#f5365c', '#a1aeb7'],
            title: {
                text: '',
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                categories: ['<b>Easy</b>', '<b>Medium</b>', '<b>Hard</b>'],
                title: {
                    text: null,
                },
            },
            yAxis: {
                lineColor: '#999',
                lineWidth: 0.5,
                min: 0,
                title: {
                    text: '',
                    align: 'high',
                },
                labels: {
                    overflow: 'justify',
                },
            },
            tooltip: {},
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        allowOverlap: true,
                    },
                },
            },
            credits: {
                enabled: false,
            },
            legend: {
                layout: 'horizontal',
                align: 'left',
                x: 6,
                // y:20,
                width: 322,
                backgroundColor:
                    Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
            },
            series: [
                {
                    name: 'Correct',
                    data: correct,
                    showInLegend: true,
                },
                {
                    name: 'InCorrect',
                    data: incorrect,
                    showInLegend: true,
                },
                {
                    name: 'Not Attempted',
                    data: notAttempted,
                    showInLegend: true,
                },
            ],
        })
    }, [])

    return (
        <div className="overalldifficulty">
            <Card>
                <div className="card-header">
                    <div className="card-overalldifficulty-text">
                        <img src={difficulty} />
                        &nbsp;&nbsp; Attempts - Diffculty level wise
                    </div>
                </div>
                <div id="overalldifficulty"></div>
            </Card>
        </div>
    )
}

export default OverAllDifficulty
